export const LOADING_DEPARTMENT = "LOADING_DEPARTMENT";
export const GET_DEPARTMENT_LIST = "GET_DEPARTMENT_LIST";
export const GET_DEPARTMENTBYID = "GET_DEPARTMENTBYID";
export const REMOVE_DEPARTMENT = "REMOVE_DEPARTMENT";
export const ADD_DEPARTMENT = "ADD_DEPARTMENT";
export const UPDATE_DEPARTMENT = "UPDATE_DEPARTMENT";